import { render } from "./UploadDocuments.vue?vue&type=template&id=97429364&scoped=true&ts=true"
import script from "./UploadDocuments.vue?vue&type=script&lang=ts"
export * from "./UploadDocuments.vue?vue&type=script&lang=ts"

import "./UploadDocuments.vue?vue&type=style&index=0&id=97429364&scoped=true&lang=css"

import exportComponent from "D:\\Github\\guardsonlinesms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97429364"]])

export default __exports__